export default "__VITE_ASSET__CELKI9$1__"